/**
 * Video hero play/pause and mobile/desktop source swap.
 * Loaded from sections/video-hero.liquid as type="module".
 */

const SELECTOR = '[data-section-type="video-hero"]'

function init(root) {
  if (root.dataset.vhInit) return
  root.dataset.vhInit = 'true'

  const media = root.querySelector('.video-hero__media-container')
  const video = root.querySelector('[data-video-hero-background]')
  const button = root.querySelector('.video-hero-background-play-button')
  const autoplay = media?.dataset.videoAutoplay !== 'false'

  if (video && button) {
    const sync = () => button.setAttribute('data-status', video.paused ? 'pause' : 'play')
    button.addEventListener('click', (e) => {
      e.preventDefault()
      if (button.dataset.status === 'play') {
        video.pause()
      } else {
        const playPromise = video.play()
        if (playPromise) playPromise.catch(() => button.setAttribute('data-status', 'pause'))
      }
      sync()
    })
    video.addEventListener('play', sync)
    video.addEventListener('pause', sync)
    if (autoplay && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      video.muted = true
      const playPromise = video.play()
      if (playPromise) playPromise.catch(() => {})
    }
  }

  if (media?.dataset.hasMobileVideo === 'true') {
    const update = () => {
      const mobile = window.matchMedia('(max-width: 719px)').matches
      const source = media.querySelector(mobile ? '.mobile-source' : '.desktop-source')
      const current = media.querySelector('.video-hero__video')
      if (!source || !current || current.src === source.src) return
      current.src = source.src
      current.load()
      current.muted = true
      if (autoplay) current.play()?.catch(() => {})
    }
    window.matchMedia('(max-width: 719px)').addEventListener('change', update)
  }
}

function initAll(scope = document) {
  if (scope.matches?.(SELECTOR)) init(scope)
  scope.querySelectorAll(SELECTOR).forEach(init)
}

initAll()
document.addEventListener('shopify:section:load', (event) => initAll(event.target))
